<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="留学最新动态列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="title"
              placeholder="search by title"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveRecentNews' }">新增留学最新动态</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listRecentNews"
          api-mode
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>

          <template slot="status" slot-scope="props">
            <va-badge :color=computeStatus(props.rowData.status).color>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>

          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateRecentNews/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal=true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除留学最新动态"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import recentNewsApi from '../../../api/liuxue/recentNews'

export default {
  data () {
    return {
      message: ['Required field'],
      recentNews: [],
      title: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteId: null,
      deleteModal: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'title',
          title: '标题',
          width: '10%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: '__slot:status',
          title: '状态',
          sortField: 'status',
          width: '10%',
        },
        {
          name: 'author',
          title: '作者',
          width: '10%',
        },
        {
          name: 'publishTime',
          title: '发布时间',
          width: '10%',
        },
        {
          name: 'source',
          title: '留学最新动态来源',
          width: '10%',
        },
        {
          name: 'description',
          title: '简短描述',
          width: '30%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.title || this.title.length < 1) {
        return this.recentNews
      }
      return this.recentNews.filter(item => {
        return item.title.toLowerCase().startsWith(this.title.toLowerCase())
      })
    },
  },
  created () {
    this.listRecentNews()
  },
  methods: {
    computeStatus: function (status) {
      const data = {
        color: 'success',
        text: '已发布',
      }
      if (status === 1) {
        data.color = 'danger'
        data.text = '草稿中'
      }
      return data
    },
    listRecentNews (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: 0,
      }
      recentNewsApi.listRecentNews(params)
        .then(response => {
          this.recentNews = response.recentNews
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmDelete () {
      recentNewsApi.deleteRecentNews(this.deleteId).then(response => {
        if (response.success === true) {
          this.listRecentNews()
        }
      })
    },
    search: debounce(function (title) {
      this.title = title
    }, 400),
    updateSortNum: function (params) {
      recentNewsApi.updateRecentNews(params.id, params).then(response => {
        if (response.success === true) {
          this.listRecentNews()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
